export function findCategoryById(categories, categoryId) {
  return categories.find(category => category?.category?.id === categoryId) || null;
}
